import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../.././../environments/environment';
import {Observable} from 'rxjs';

const apiUrl: string = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ParamService {

  constructor(private http: HttpClient) {
  }

  obtenerListaParametros(page, page_size, tipo, nombre, canal = '') {
    return this.http.post<any>(`${apiUrl}/adm/param/list/`, {
      page, page_size, tipo, nombre, canal
    });

  }

  obtenerListaTipos() {
    return this.http.get<any>(`${apiUrl}/adm/param/list/tipo/`);
  }

  insertarParametro(
    nombre,
    tipo,
    descripcion,
    tipoVariable,
    valor,
    idPadre,
    canal,
    tipo_entrega,
    tiempo_entrega,
    tiempo_limite_metodo_entrega,
    localizacion,
    monto_limite,
    activar_todos_sectores,
    marketplace_unico,
    tienda_padre,
    enlace_tienda_padre,
    dominio,
    tiene_marca_propia = 0,
    logo_comercial = null
  ) {
    if (tiene_marca_propia && logo_comercial instanceof File) {
      const formData = new FormData();
      formData.append('nombre', nombre || '');
      formData.append('tipo', tipo || '');
      formData.append('descripcion', descripcion || '');
      formData.append('tipoVariable', tipoVariable || '');
      formData.append('valor', valor || '');
      formData.append('idPadre', idPadre !== undefined && idPadre !== null ? idPadre.toString() : '0');
      formData.append('canal', canal || '');
      formData.append('tipo_entrega', tipo_entrega || '');
      formData.append('tiempo_entrega', tiempo_entrega || '');
      formData.append('tiempo_limite_metodo_entrega', tiempo_limite_metodo_entrega || '');
      formData.append('localizacion', JSON.stringify(localizacion || []));
      formData.append('monto_limite', monto_limite !== undefined && monto_limite !== null ? monto_limite.toString() : '0');
      formData.append('activar_todos_sectores', activar_todos_sectores !== undefined && activar_todos_sectores !== null ? activar_todos_sectores.toString() : '0');
      formData.append('marketplace_unico', marketplace_unico !== undefined && marketplace_unico !== null ? marketplace_unico.toString() : '0');
      formData.append('tienda_padre', tienda_padre !== undefined && tienda_padre !== null ? tienda_padre.toString() : '0');
      formData.append('enlace_tienda_padre', enlace_tienda_padre || '');
      formData.append('dominio', dominio || '');
      formData.append('tiene_marca_propia', tiene_marca_propia !== undefined && tiene_marca_propia !== null ? tiene_marca_propia.toString() : '0');
      formData.append('logo_comercial', logo_comercial);
      return this.http.post<any>(`${apiUrl}/adm/param/create/`, formData);
    }

    const payload: any = {
      nombre,
      tipo,
      descripcion,
      tipoVariable,
      valor,
      idPadre,
      canal,
      tipo_entrega,
      tiempo_entrega,
      tiempo_limite_metodo_entrega,
      localizacion,
      monto_limite,
      activar_todos_sectores,
      marketplace_unico,
      tienda_padre,
      enlace_tienda_padre,
      dominio,
      tiene_marca_propia: tiene_marca_propia ? 1 : 0
    };

    return this.http.post<any>(`${apiUrl}/adm/param/create/`, payload);
  }

  editarParametro(
    id,
    nombre,
    tipo,
    descripcion,
    tipoVariable,
    valor,
    idPadre,
    canal,
    tipo_entrega,
    tiempo_entrega,
    tiempo_limite_metodo_entrega,
    localizacion,
    monto_limite,
    activar_todos_sectores,
    marketplace_unico,
    tienda_padre,
    enlace_tienda_padre,
    dominio,
    tiene_marca_propia = 0,
    logo_comercial = null
  ) {
    if (tiene_marca_propia && logo_comercial instanceof File) {
      const formData = new FormData();
      formData.append('nombre', nombre || '');
      formData.append('tipo', tipo || '');
      formData.append('descripcion', descripcion || '');
      formData.append('tipoVariable', tipoVariable || '');
      formData.append('valor', valor || '');
      formData.append('idPadre', idPadre !== undefined && idPadre !== null ? idPadre.toString() : '0');
      formData.append('canal', canal || '');
      formData.append('tipo_entrega', tipo_entrega || '');
      formData.append('tiempo_entrega', tiempo_entrega || '');
      formData.append('tiempo_limite_metodo_entrega', tiempo_limite_metodo_entrega || '');
      formData.append('localizacion', JSON.stringify(localizacion || []));
      formData.append('monto_limite', monto_limite !== undefined && monto_limite !== null ? monto_limite.toString() : '0');
      formData.append('activar_todos_sectores', activar_todos_sectores !== undefined && activar_todos_sectores !== null ? activar_todos_sectores.toString() : '0');
      formData.append('marketplace_unico', marketplace_unico !== undefined && marketplace_unico !== null ? marketplace_unico.toString() : '0');
      formData.append('tienda_padre', tienda_padre !== undefined && tienda_padre !== null ? tienda_padre.toString() : '0');
      formData.append('enlace_tienda_padre', enlace_tienda_padre || '');
      formData.append('dominio', dominio || '');
      formData.append('tiene_marca_propia', tiene_marca_propia !== undefined && tiene_marca_propia !== null ? tiene_marca_propia.toString() : '0');
      formData.append('logo_comercial', logo_comercial);
      return this.http.post<any>(`${apiUrl}/adm/param/update/${id}`, formData);
    }

    const payload: any = {
      nombre,
      tipo,
      descripcion,
      tipoVariable,
      valor,
      idPadre,
      canal,
      tipo_entrega,
      tiempo_entrega,
      tiempo_limite_metodo_entrega,
      localizacion,
      monto_limite,
      activar_todos_sectores,
      marketplace_unico,
      tienda_padre,
      enlace_tienda_padre,
      dominio,
      tiene_marca_propia: tiene_marca_propia ? 1 : 0
    };

    return this.http.post<any>(`${apiUrl}/adm/param/update/${id}`, payload);
  }

  eliminarParametro(id) {
    return this.http.delete<any>(`${apiUrl}/adm/param/delete/${id}`);
  }

  obtenerParametro(id) {
    return this.http.get<any>(`${apiUrl}/adm/param/listOne/${id}`);
  }

  obtenerListaPadres(tipo) {
    return this.http.post<any>(`${apiUrl}/adm/param/list/tipo/todos/`, {tipo});
  }

  obtenerListaHijos(nombre, tipo, idSector = ''): Observable<any> {
    return this.http.post<any>(`${apiUrl}/mdm/param/list/filtro/nombre`, {tipo, nombre, idSector});
  }

  obtenerListaHijosEnvio(nombre): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/param/list/tipo/hijo/nombre/`, {nombre});
  }

  actualizarConfiguracionFormaEntrega(datos): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/param/update/configuracion/forma-entrega/`, datos);
  }

  obtenerURL(url): string {
    return `${apiUrl}${url}`;
  }

  exportarUsuarios(): Observable<any> {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<any>(
      `${environment.apiUrl}/adm/param/exportar/`, httpOptions);
  }

  convertirImagenBase64(url: string): Observable<any> {
    return this.http.post<any>(`${apiUrl}/adm/param/convertir/base64/`, {url: url});
  }
}
